<template>
  <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
             dense
              v-model="dateFormatted"
              :label="label"
              v-bind="attrs"
              clearable
              readonly
              :class="inputClass"
              v-on="on"
              @click:clear="clearDate"
              :rules="rules"
            ></v-text-field>
          </template>
          <v-date-picker v-model="dates" :allowed-dates="alloweDates" :min="min" :max="max" range no-title @input="emitChange()"></v-date-picker>
        </v-menu>  
</template>
<script>
export default {
    name:"DateRangeInput",
    props:['value','label','rules','inputClass','alloweDates','min','max'],
    data(){
        return{
            menu:false,
            dates:[],
        }
    },
    computed:{
      dateFormatted(){
        if(!this.dates ||this.dates.length != 2){
          return null;
        }
        return this.formatDateRange(this.dates)
      }
    },
    created(){
        if(this.value){
            this.dates = this.value;
        }
        this.emitChange();
    },
    methods:{
        emitChange(){
            this.$emit("input",this.dates)
            if(this.dates && this.dates.length == 2){
              this.menu = false;
            }
        },
        clearDate(){
            this.dates = [];
            this.emitChange();
        },
        formatDateRange(date){
            date.sort();

            const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',timeZone: 'UTC' };
            const dt1 = new Date(date[0]);
            const dt2 = new Date(date[1]);
            return dt1.toLocaleDateString("en-US", options)+" To "+dt2.toLocaleDateString("en-US",options);

        }
    }
}
</script>
